// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.subscription {
  width: 100%;
  margin-inline: auto;
  margin-bottom: 60px;
  padding: 30px 15px;
  background-color: #F1F1F2;
  position: relative;
  z-index: 0;
}
.subscription::before, .subscription::after {
  content: "";
  position: absolute;
  top: 0;
  height: 100%;
  background-color: inherit;
  width: 50vw;
  right: 100%;
  z-index: -1;
}
.subscription::after {
  right: auto;
  left: 100%;
}
.subscription__header {
  text-align: center;
  margin-bottom: 42px;
}
.subscription__header-title {
  max-width: 500px;
  margin: 0 auto 25px;
  font-family: "Museo-700";
  font-size: 50px;
  color: #6d6e71;
}
@media only screen and (max-width: 767px) {
  .subscription__header-title {
    font-size: 24px;
  }
}
.subscription__header-description {
  font-family: "Museo-300" !important;
  font-size: 16px;
  line-height: 1.6;
  color: #555;
}
.subscription__slider {
  min-height: 100px;
  margin-bottom: 42px;
  width: min(804px, 100%);
  margin-inline: auto;
}
@media (max-width: 767px) {
  .subscription__slider {
    margin-bottom: 30px;
  }
}
.subscription__slider ::ng-deep .ngx-slider .ngx-slider-pointer {
  background-color: #69be29 !important;
  opacity: 1;
  visibility: visible;
  transform: rotate(0deg);
  background: url(https://www.foursightonline.com/hubfs/2025/range-icon.svg) 0% 0%/100% no-repeat;
  border: 2px solid rgb(255, 255, 255);
  border-radius: 16px;
  cursor: pointer !important;
  appearance: none;
  z-index: 3;
  width: 40px !important;
  height: 24px !important;
  top: -11px !important;
}
.subscription__slider ::ng-deep .ngx-slider .ngx-slider-pointer::after {
  content: none !important;
}
.subscription__slider ::ng-deep .ngx-slider .ngx-slider-tick {
  cursor: pointer;
  width: 1px !important;
  height: 10px !important;
  background: black !important;
  border-radius: 50%;
  position: absolute;
  top: 8px !important;
  left: 8px !important;
  margin-left: 11px;
}
@media (max-width: 767px) {
  .subscription__slider ::ng-deep .ngx-slider .ngx-slider-tick {
    width: 0 !important;
    height: 0 !important;
  }
}
.subscription__slider ::ng-deep .ngx-slider .ngx-slider-bubble {
  display: none !important;
}
.subscription__slider ::ng-deep .ngx-slider .ngx-slider-bar {
  left: 0;
  width: 100%;
  height: 2px !important;
  background: grey !important;
  border-radius: 2px;
  z-index: 1;
}
.subscription__slider ::ng-deep .ngx-slider .ngx-slider-bar::before, .subscription__slider ::ng-deep .ngx-slider .ngx-slider-bar::after {
  content: "" !important;
  width: 50px !important;
  height: 2px !important;
  background: linear-gradient(to right, rgba(255, 255, 255, 0.9) 0%, transparent 100%) !important;
  position: absolute !important;
  top: 0px !important;
}
.subscription__slider ::ng-deep .ngx-slider .ngx-slider-bar::after {
  background: linear-gradient(to left, rgba(255, 255, 255, 0.9) 0%, transparent 100%) !important;
  right: 0px !important;
  left: auto !important;
}
.subscription__slider ::ng-deep.ngx-slider-inner-tooltip {
  font-size: 16px;
  color: #444;
  padding: 7px 10px;
  width: auto !important;
  height: auto !important;
  line-height: 1;
  min-width: 52px;
}
@media (max-width: 767px) {
  .subscription__slider ::ng-deep.ngx-slider-inner-tooltip {
    min-width: 17px;
    font-size: 10px;
  }
}
.subscription__slider ::ng-deep.ngx-slider-inner-tooltip.active {
  background-color: #f1f1f1 !important;
  width: 40px;
  height: 21px;
  border-radius: 50px;
  color: #444;
}
.subscription__plans {
  display: flex;
  flex-wrap: wrap;
  margin-top: 55px;
  gap: 60px;
}
@media (max-width: 991px) {
  .subscription__plans {
    gap: 30px;
  }
}
@media (max-width: 767px) {
  .subscription__plans {
    margin-top: 0;
  }
}
.subscription__plan {
  display: flex;
  flex-wrap: wrap;
  width: calc(33.3333333333% - 40px);
  border-radius: 5px;
  border: 2px solid #f1f1f1;
  background: #FFFFFF;
  padding: 30px 28px 82px;
  position: relative;
}
@media (max-width: 991px) {
  .subscription__plan {
    width: 100%;
    padding: 30px 15px 82px;
  }
}
.subscription__plan-content {
  flex: 1;
}
.subscription__plan-content ul {
  padding: 0;
  margin: 0;
  list-style: none;
}
.subscription__plan-content ul li {
  font-size: 18px;
  color: #666;
  line-height: 1.6;
  border-bottom: 2px dashed rgba(102, 102, 102, 0.2);
  padding-left: 29px;
  padding-bottom: 9px;
  margin-bottom: 7px;
  position: relative;
}
@media (max-width: 767px) {
  .subscription__plan-content ul li {
    font-size: 16px;
  }
}
.subscription__plan-content ul li:before {
  content: "";
  width: 19px;
  height: 14px;
  background: url(https://www.foursightonline.com/hubfs/2025/arrow_accent_perfect.svg) no-repeat;
  background-size: cover;
  position: absolute;
  top: 8px;
  left: 0;
}
.subscription__plan-content ul li ul {
  padding: 0;
  margin: 15px 0 0 0;
  list-style: none;
}
.subscription__plan-content ul li ul li {
  padding-left: 16px;
}
.subscription__plan-content ul li ul li:before {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #676A6C;
  top: 11px;
}
.subscription__plan-content ul:last-child li:last-child {
  border-bottom: none;
}
.subscription__plan-title {
  font-size: 24px;
  font-weight: 400;
  font-family: "Conv_museo-500-webfont";
  color: #666;
  line-height: 1.25;
  margin-bottom: 32px;
}
@media (max-width: 767px) {
  .subscription__plan-title {
    font-size: 20px;
  }
}
.subscription__plan-feature {
  font-size: 16px;
  line-height: 1.4;
  color: #444;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.subscription__plan-desc {
  margin-bottom: 16px;
}
.subscription__plan-footer {
  margin-top: auto;
  width: 100%;
}
.subscription__plan-price {
  font-size: 22px;
  font-weight: 600;
  color: #444;
}
.subscription__plan-price-main {
  font-family: "Museo-700";
  font-size: 24px;
  color: #666;
}
@media (max-width: 767px) {
  .subscription__plan-price-main {
    font-size: 20px;
  }
}
.subscription__plan-price-note {
  font-size: 14px;
  font-weight: 400;
  color: #666;
}
.subscription__plan-savings {
  min-height: 30px;
  font-size: 18px;
  font-family: "Museo-700";
  color: #666;
  line-height: 1.66;
}
.subscription__submit-btn {
  background-color: rgb(105, 190, 40);
  color: white;
  padding: 8px 24px;
  border: none;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
  width: 100%;
  font-size: 16px;
  transition: background-color 0.3s ease;
  width: calc(100% - 56px);
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  font-family: "Conv_museo-500-webfont";
  text-align: center;
}
.subscription__submit-btn:hover {
  background-color: #06aed0;
}

::ng-deep.ngx-slider-ticks > span:last-child .ngx-slider-tick-value .ngx-slider-inner-tooltip {
  position: relative;
}
::ng-deep.ngx-slider-ticks > span:last-child .ngx-slider-tick-value .ngx-slider-inner-tooltip:after {
  content: "+";
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/store/public-store/subscription-slider/subscription-slider.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA9YA;EACE,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;AAiZF;AA/YE;EAEM,WAAA;EACA,kBAAA;EACA,MAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;AAgZR;AA7YE;EACI,WAAA;EACA,UAAA;AA+YN;AA5YE;EACE,kBAAA;EACA,mBAAA;AA8YJ;AA5YI;EACE,gBAAA;EACA,mBAAA;EACA,wBAAA;EACA,eAAA;EACA,cAAA;AA8YN;AA5YM;EAPF;IAQI,eAAA;EA+YN;AACF;AA5YI;EACE,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AA8YN;AA1YE;EACE,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AA4YJ;AA1YI;EANF;IAOI,mBAAA;EA6YJ;AACF;AA1YM;EACE,oCAAA;EACA,UAAA;EACA,mBAAA;EACA,uBAAA;EACA,+FAAA;EACA,oCAAA;EACA,mBAAA;EACA,0BAAA;EACA,gBAAA;EACA,UAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AA4YR;AA1YQ;EACE,wBAAA;AA4YV;AAxYM;EACE,eAAA;EACA,qBAAA;EACA,uBAAA;EACA,4BAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBAAA;AA0YR;AAxYQ;EAXF;IAYI,mBAAA;IACA,oBAAA;EA2YR;AACF;AAvYM;EACE,wBAAA;AAyYR;AAtYM;EACE,OAAA;EACA,WAAA;EACA,sBAAA;EACA,2BAAA;EACA,kBAAA;EACA,UAAA;AAwYR;AAtYQ;EAEE,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,+FAAA;EACA,6BAAA;EACA,mBAAA;AAuYV;AApYQ;EACE,8FAAA;EACA,qBAAA;EACA,qBAAA;AAsYV;AAlYI;EACE,eAAA;EACA,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AAoYN;AAlYM;EATF;IAUI,eAAA;IACA,eAAA;EAqYN;AACF;AAnYM;EACE,oCAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EAGA,WAAA;AAmYR;AA9XE;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AAgYJ;AA9XI;EANF;IAOI,SAAA;EAiYJ;AACF;AA/XI;EAVF;IAWI,aAAA;EAkYJ;AACF;AA/XE;EACE,aAAA;EACA,eAAA;EACA,kCAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAiYJ;AA/XI;EAVF;IAWI,WAAA;IACA,uBAAA;EAkYJ;AACF;AAhYI;EACE,OAAA;AAkYN;AAhYM;EACE,UAAA;EACA,SAAA;EACA,gBAAA;AAkYR;AAhYQ;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,kDAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAkYV;AAhYU;EAVF;IAWI,eAAA;EAmYV;AACF;AAjYU;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,8FAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;AAmYZ;AAhYU;EACE,UAAA;EACA,kBAAA;EACA,gBAAA;AAkYZ;AAhYY;EACE,kBAAA;AAkYd;AAhYc;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;AAkYhB;AA1XU;EACE,mBAAA;AA4XZ;AApXI;EACE,eAAA;EACA,gBAAA;EACA,qCAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;AAsXN;AApXM;EARF;IASI,eAAA;EAuXN;AACF;AApXI;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AAsXN;AAlXI;EACE,mBAAA;AAoXN;AAjXI;EACE,gBAAA;EACA,WAAA;AAmXN;AAhXI;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AAkXN;AAhXM;EACE,wBAAA;EACA,eAAA;EACA,WAAA;AAkXR;AAhXQ;EALF;IAMI,eAAA;EAmXR;AACF;AA/WM;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AAiXR;AA7WI;EACE,gBAAA;EACA,eAAA;EACA,wBAAA;EACA,WAAA;EACA,iBAAA;AA+WN;AA1WE;EACE,mCAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,qCAAA;EACA,kBAAA;AA4WJ;AA1WI;EACE,yBAAA;AA4WN;;AApWM;EACE,kBAAA;AAuWR;AAtWQ;EACE,YAAA;AAwWV","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import '../../../../../assets//styles/variables';\n.subscription {\n  width: 100%;\n  margin-inline: auto;\n  margin-bottom: 60px;\n  padding: 30px 15px;\n  background-color: #F1F1F2;\n  position: relative;\n  z-index: 0;\n\n  &::before,\n  &::after {\n        content: '';\n        position: absolute;\n        top: 0;\n        height: 100%;\n        background-color: inherit;\n        width: 50vw;\n        right: 100%;\n        z-index: -1;\n  }\n\n  &::after {\n      right: auto;\n      left: 100%;\n  }\n\n  &__header {\n    text-align: center;\n    margin-bottom: 42px;\n\n    &-title {\n      max-width: 500px;\n      margin: 0 auto 25px;\n      font-family: 'Museo-700';\n      font-size: 50px;\n      color: #6d6e71;\n\n      @media #{$mobile} {\n        font-size: 24px;\n      }\n    }\n\n    &-description {\n      font-family: 'Museo-300' !important;\n      font-size: 16px;\n      line-height: 1.6;\n      color: #555;\n    }\n  }\n\n  &__slider {\n    min-height: 100px;\n    margin-bottom: 42px;\n    width: min(804px, 100%);\n    margin-inline: auto;\n\n    @media (max-width: 767px){\n      margin-bottom: 30px;\n    }\n\n    ::ng-deep .ngx-slider {\n      .ngx-slider-pointer {\n        background-color: #69be29 !important;\n        opacity: 1;\n        visibility: visible;\n        transform: rotate(0deg);\n        background: url(https://www.foursightonline.com/hubfs/2025/range-icon.svg) 0% 0% / 100% no-repeat;\n        border: 2px solid rgb(255, 255, 255); \n        border-radius: 16px;\n        cursor: pointer !important;\n        appearance: none;\n        z-index: 3;\n        width:40px !important;\n        height: 24px !important;\n        top: -11px !important;\n\n        &::after {\n          content: none !important;\n        }\n      }\n\n      .ngx-slider-tick {\n        cursor: pointer;\n        width: 1px !important;\n        height: 10px !important;\n        background: black !important;\n        border-radius: 50%;\n        position: absolute;\n        top: 8px !important;\n        left: 8px !important;\n        margin-left: 11px;\n\n        @media (max-width: 767px){\n          width: 0 !important;\n          height: 0 !important;\n        }\n\n      }\n\n      .ngx-slider-bubble {\n        display: none !important;\n      }\n\n      .ngx-slider-bar {\n        left: 0;\n        width: 100%;\n        height: 2px !important;\n        background: grey !important;\n        border-radius: 2px;\n        z-index: 1;\n\n        &::before,\n        &::after {\n          content: \"\" !important;\n          width: 50px !important;\n          height: 2px !important;\n          background: linear-gradient(to right, rgba(255, 255, 255, 0.9) 0%, transparent 100%) !important;\n          position: absolute !important;\n          top: 0px !important;\n        }\n\n        &::after {\n          background: linear-gradient(to left, rgba(255, 255, 255, 0.9) 0%, transparent 100%) !important;\n          right: 0px !important;\n          left: auto !important;\n        }\n      }\n    }\n    ::ng-deep.ngx-slider-inner-tooltip {\n      font-size: 16px;\n      color: #444;\n      padding: 7px 10px;\n      width: auto !important;\n      height: auto !important;\n      line-height: 1;\n      min-width: 52px;\n\n      @media (max-width: 767px){\n        min-width: 17px;\n        font-size: 10px;\n      }\n\n      &.active {\n        background-color: #f1f1f1 !important;\n        width: 40px;\n        height: 21px;\n        border-radius: 50px;\n        // padding: 7px 10px;\n        // font-size: 16px;\n        color: #444;\n      }\n    }\n  }\n\n  &__plans {\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: 55px;\n    gap: 60px;\n\n    @media (max-width: 991px) {\n      gap: 30px;\n    }\n\n    @media (max-width: 767px){\n      margin-top: 0;\n    }\n  }\n\n  &__plan {\n    display: flex;\n    flex-wrap: wrap;\n    width: calc(100% / 3 - 40px);\n    border-radius: 5px;\n    border: 2px solid #f1f1f1;\n    background: #FFFFFF;\n    padding: 30px 28px 82px;\n    position: relative;\n\n    @media (max-width: 991px){\n      width: 100%;\n      padding: 30px 15px 82px;\n    }\n\n    &-content {\n      flex: 1;\n\n      ul{\n        padding: 0;\n        margin: 0;\n        list-style: none;\n\n        li{\n          font-size: 18px;\n          color: #666;\n          line-height: 1.6;\n          border-bottom: 2px dashed rgba(102, 102, 102, 0.2);\n          padding-left: 29px;\n          padding-bottom: 9px;\n          margin-bottom: 7px;\n          position: relative;\n\n          @media (max-width: 767px){\n            font-size: 16px;\n          }\n          \n          &:before{\n            content: \"\";\n            width: 19px;\n            height: 14px;\n            background: url(https://www.foursightonline.com/hubfs/2025/arrow_accent_perfect.svg) no-repeat;\n            background-size: cover;\n            position: absolute;\n            top: 8px;\n            left: 0;\n          }\n\n          ul{\n            padding: 0;\n            margin: 15px 0 0 0;\n            list-style: none;\n\n            li{\n              padding-left: 16px;\n\n              &:before{\n                width: 6px;\n                height: 6px;\n                border-radius: 50%;\n                background: #676A6C;\n                top: 11px;\n              }\n            }\n          }\n\n        }\n\n        &:last-child{\n          li:last-child{\n            border-bottom: none;\n          }\n        }\n\n      }\n\n    }\n\n    &-title {\n      font-size: 24px;\n      font-weight: 400;\n      font-family: \"Conv_museo-500-webfont\";\n      color: #666;\n      line-height: 1.25;\n      margin-bottom: 32px;\n\n      @media (max-width: 767px){\n        font-size: 20px;\n      }\n    }\n\n    &-feature {\n      font-size: 16px;\n      line-height: 1.4;\n      color: #444;\n      margin-bottom: 10px;\n      display: flex;\n      align-items: center;\n\n    }\n\n    &-desc {\n      margin-bottom: 16px;\n    }\n\n    &-footer {\n      margin-top: auto;\n      width: 100%;\n    }\n\n    &-price {\n      font-size: 22px;\n      font-weight: 600;\n      color: #444;\n\n      &-main {\n        font-family: 'Museo-700';\n        font-size: 24px;\n        color: #666;\n\n        @media (max-width: 767px) {\n          font-size: 20px;\n        }\n\n      }\n\n      &-note {\n        font-size: 14px;\n        font-weight: 400;\n        color: #666;\n      }\n    }\n\n    &-savings {\n      min-height: 30px;\n      font-size: 18px;\n      font-family: 'Museo-700';\n      color: #666;\n      line-height: 1.66;\n\n    }\n  }\n\n  &__submit-btn {\n    background-color: rgb(105, 190, 40);\n    color: white;\n    padding: 8px 24px;\n    border: none;\n    border-radius: 4px;\n    font-weight: bold;\n    cursor: pointer;\n    width: 100%;\n    font-size: 16px;\n    transition: background-color 0.3s ease;\n    width: calc(100% - 56px);\n    position: absolute;\n    bottom: 30px;\n    left: 50%;\n    transform: translateX(-50%);\n    font-family: \"Conv_museo-500-webfont\";\n    text-align: center;\n\n    &:hover {\n      background-color: #06aed0;\n    }\n  }\n}\n\n::ng-deep.ngx-slider-ticks{\n  & > span:last-child{\n    .ngx-slider-tick-value{\n      .ngx-slider-inner-tooltip{\n        position: relative;\n        &:after{\n          content: \"+\";  \n        }\n      }\n    }\n  }\n}\n\n\n\n\n\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
